













































































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import VueRouter from "vue-router";
import { Validator } from "vee-validate";
import Input from "@/shared/components/ui/Input.vue";
import ErrorSummary from "@/shared/components/ErrorSummary.vue";
import EmployerPhone from "@/employer/components/shared/EmployerPhone.vue";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";

@Component({
  components: {
    Input,
    EmployerPhone,
    ErrorSummary
  }
})
export default class PartnerSupport extends Vue {
  $router: VueRouter;
  $validator: Validator;

  portalCustomizationStore = usePortalCustomizationStore();

  isSubmitting = false;
  supportPhone = "";
  supportEmail = "";
  supportWebsite = "";
  customFromEmail = "";

  @Prop() partnerId: number;

  mounted () {
    this.onPartnerIdChanged(this.partnerId);
    this.initialize();
  }

  @Watch("partnerId")
  onPartnerIdChanged (partnerId) {
    this.portalCustomizationStore.getSupportInfo({ partnerId, employerId: 0 });
  }

  get submitDisabled () {
    return this.$validator.errors.any() || this.isSubmitting;
  }

  @Watch("portalCustomizationStore.isSupportInfoLoaded")
  initialize () {
    if (this.portalCustomizationStore.isSupportInfoLoaded && !this.portalCustomizationStore.supportInfo.isFallbackData) {
      this.supportPhone = this.portalCustomizationStore.supportInfo.supportPhone;
      this.supportEmail = this.portalCustomizationStore.supportInfo.supportEmail;
      this.supportWebsite = this.portalCustomizationStore.supportInfo.supportWebsite;
      this.customFromEmail = this.portalCustomizationStore.supportInfo.customFromEmail;
    }
  }

  submit () {
    this.$validator.validateAll()
        .then(isValid => {
          if (!isValid) {
            return;
          }

          this.isSubmitting = true;
          this.portalCustomizationStore.savePartnerSupportInfo({
                partnerId: this.partnerId,
                supportInfo: {
                  supportEmail: this.supportEmail,
                  supportWebsite: this.supportWebsite,
                  supportPhone: this.supportPhone,
                  customFromEmail: this.customFromEmail
                }
              })
              .then(resp => {
                this.isSubmitting = false;
              });
        });
  }


}
